import Axios from "axios";
import {config} from "@/config";
import Vue from "vue";

Axios.defaults.baseURL = config.apiUrl;
Axios.defaults.headers.common['Content-Type'] = 'application/json';
export default {
    namespaced: true,
    modules: {
    },
    state: {
        items: [],
        pagination: {
            total: 0,
            limit: 20,
            currentPage: 1,
        },
        localTotalData: {

        },
        totalData: {
            total: 0,
            processed: 0
        },
    },
    getters: {
        getLocalTotalDataById: (state) => (id) => {
            return state.localTotalData[id] !== undefined ?
                state.localTotalData[id] :
                {
                    total: 0,
                    processed: 0
                }
        },
    },
    mutations: {
        SET_ITEMS: (state, payload) => {
            return state.items = payload;
        },
        SET_PAGINATION: (state, payload) => {
            return state.pagination = payload;
        },
        SET_TOTAL_DATA: (state, payload) => {
            return state.totalData = payload;
        },
        SET_LOCAL_TOTAL_DATA: (state, {data, id}) => {
            return Vue.set(state.localTotalData, id, data);
        },
    },
    actions: {
        GET_LIST: ({dispatch, commit}, params) => {
            let url = '/ai/test';
            const queryParams = [];
            Object.keys(params).map((key,index) => {
                if(params[key] !== ''){
                    queryParams.push(`${key}=${encodeURIComponent(params[key])}`)
                }
            })
            const sQueryParams = queryParams.join('&')
            url = `${url}?${sQueryParams}`
            dispatch('SEND_GET', {
                url,
                getSuccessResponse: (responseData)=>{
                    commit('SET_ITEMS', responseData.content);
                    commit('SET_PAGINATION', {total: responseData.total, limit: responseData.limit, currentPage: params.page});
                },
                showSuccessMessage: false
            }, { root: true });
        },
        DELETE_ITEM: ({dispatch, commit, state}, {id, th}) => {
            return dispatch('SEND_DELETE', {
                url: 'ai/test/' + id,
                getSuccessResponse: ()=>{
                    let items   = state.items.filter((item)=>{
                        return item.id !== id
                    })
                    commit('SET_ITEMS', items);
                },
                showSuccessMessage: true,
                th
            }, { root: true });
        },
        GET_TOTAL: ({commit, getters, dispatch}, payload) => {
            let urlParams = payload.th.createParamsUrl(payload.urlParams ? payload.urlParams : '');
            dispatch('SEND_GET', {
                th: payload.th,
                url: '/ai/test/total' + urlParams + '&token=asdasd',
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if(payload.urlParams?.type) {
                        commit('SET_LOCAL_TOTAL_DATA', {data: responseData.data, id: payload.urlParams.id});
                    } else {
                        commit('SET_TOTAL_DATA', responseData.data);
                    }

                }
            }, { root: true });
        },
    }
}